import Register from '../Pages/Register.vue'
import Login from '../Pages/Login.vue'
import ResetPassword from '../Pages/ResetPassword.vue'
import ForgotPassword from '../Pages/ForgotPassword.vue'
import SecurityPage from "../Views/SecurityPage.vue";
import VerifyEmail from '../Pages/VerifyEmail.vue'
import EmailVerified from '../Pages/EmailVerified.vue'
import VerifyEmailPassword from '../Pages/VerifyEmailPassword.vue'
import SSOLogout from '../Pages/SSOLogout.vue'
import SSOError from '../Pages/SSOError.vue'
import AgeVerification from "../Pages/AgeVerification"
import VerifyParentEmail from "../Pages/VerifyParentEmail"
import ParentConsentConfirmed from "../Pages/ParentConsentConfirmed";
import ChangePassword from "../Pages/ChangePassword";

const routes = [
    {
        path: '/',
        component: SecurityPage,
        children: [
            {
                path: '/',
                name: 'Login',
                component: Login,
            },
            {
                path: '/register',
                name: 'Register',
                component: Register,
            },
            {
                path: '/reset_password',
                name: 'ResetPassword',
                component: ResetPassword,
            },
            {
                path: '/forgot_password',
                name: 'ForgotPassword',
                component: ForgotPassword,
            },
            {
                path: '/verify_Email',
                name: 'VerifyEmail',
                component: VerifyEmail,
            },
            {
                path: '/verify_parent_email',
                name: 'VerifyParentEmail',
                component: VerifyParentEmail,
            },
            {
                path: '/email_verified',
                name: 'EmailVerified',
                component: EmailVerified,
            },
            {
                path: '/verify_email_password',
                name: 'VerifyEmailPassword',
                component: VerifyEmailPassword,
            },
            {
                path: '/sso_logout',
                name: 'SSOLogout',
                component: SSOLogout,
            },
            {
                path: '/sso_error',
                name: 'beErrorSSOIdp',
                component: SSOError,
            },
            {
                path: '/change_password',
                name: 'ChangePassword',
                component: ChangePassword,
            },
            {
                path: '/parent_consent_confirmed',
                name: 'ParentConsentConfirmed',
                component: ParentConsentConfirmed,
            },
            {
                path: '/:userId/parent_consent',
                name: 'ParentConsentRequired',
                component: AgeVerification,
            },
            {
                path: '/sso/:id_token',
                name: 'SSOLogin',
                component: Login,
            }
        ]
    }
]

export default routes